function ParagraphIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.5 10.5C4.5 6.35786 7.85786 3 12 3H18.5V5H12C8.96243 5 6.5 7.46243 6.5 10.5C6.5 13.5376 8.96243 16 12 16H18.5V18H12C7.85786 18 4.5 14.6421 4.5 10.5Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5 3H23.5C24.6046 3 25.5 3.89543 25.5 5V30C25.5 30.5523 25.0523 31 24.5 31C23.9477 31 23.5 30.5523 23.5 30V5H19.5V30C19.5 30.5523 19.0523 31 18.5 31C17.9477 31 17.5 30.5523 17.5 30V3Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.5 30C14.5 29.4477 14.9477 29 15.5 29L27.5 29C28.0523 29 28.5 29.4477 28.5 30C28.5 30.5523 28.0523 31 27.5 31L15.5 31C14.9477 31 14.5 30.5523 14.5 30Z'
        />
      </svg>
    </span>
  );
}

export default ParagraphIcon;
